import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import {
  GetDefects,
  GetEmbalagens,
  GetTipoEmbalagens,
  PostTipoEmbalagem,
  RemoveTipoEmbalagem,
} from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarTipoEmbalagem from "./AdicionarTipoEmbalagem";
import EditarTipoEmbalagem from "./EditarTipoEmbalagem";

const AdminTipoEmbalagens = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  const [embalagens, setEmbalagens] = useState<any>([]);
  const [tipoEmbalagensOptions, setTipoEmbalagensOptions] = useState<any>([]);
  const [defects, setDefects] = useState<any>([]);

  const [selectedTipoEmbalagem, setSelectedTipoEmbalagem] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [editarTipo, setEditarTipo] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    GetEmbalagens(setEmbalagens);
    GetTipoEmbalagens(setTipoEmbalagensOptions);
    GetDefects(setDefects);
  }, []);

  // Salvar e atualizar lista
  async function handleSaveTipo(tipos: { tipoEmbalagem: string }) {
    try {

      await PostTipoEmbalagem(tipos);
      GetEmbalagens(setEmbalagens);
      GetTipoEmbalagens(setTipoEmbalagensOptions);
      GetDefects(setDefects);
      setOpenAdicionar(false);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await RemoveTipoEmbalagem(selectedTipoEmbalagem.idTipoEmbalagem);
      toast.success("Emmbalagem deletada com sucesso!");
      setTipoEmbalagensOptions((prev: any[]) =>
        prev.filter(
          (item) => item.tipoEmbalagem !== selectedTipoEmbalagem.tipoEmbalagem
        )
      );
    } catch (error) {
      toast.error("Erro ao deletar embalagem.");
    } finally {
      toggleModal();
    }
  };

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Id</td>
        <td className="listProperty">Tipo de embalagem</td>
        {adm && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {tipoEmbalagensOptions
          ?.sort(function (a: any, b: any) {
            if (a.tipoEmbalagem > b.tipoEmbalagem) {
              return 1;
            }
            if (a.tipoEmbalagem < b.tipoEmbalagem) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <tr
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 5,
                  borderBottom: "1px solid #dddddd",
                }}
              >
                <td className="listTd">{item.idTipoEmbalagem}</td>
                <td className="listTd">{item.tipoEmbalagem}</td>
                {adm && (
                  <div style={{ display: "flex", flex: 1, marginLeft: 3 }}>
                    <button
                      className="editBtn"
                      onClick={() => {
                        setSelectedTipoEmbalagem(item);
                        setEditarTipo(true);
                      }}
                    >
                      Editar
                    </button>
                    <button
                      className="deleteUserBtn"
                      onClick={() => {
                        setSelectedTipoEmbalagem(item);
                        setIsModalOpen(true);
                      }}
                    >
                      Deletar
                    </button>
                  </div>
                )}
              </tr>
            );
          })}
      </>
    );
  }, [tipoEmbalagensOptions]);

  return (
    <>
      {editarTipo ? (
        <EditarTipoEmbalagem val={selectedTipoEmbalagem} defeitos={defects} />
      ) : (
        <div className="modalSignUp">
          <div className="content-header-button-and-title">
            <h1>TipoEmbalagens</h1>

            {adm && (
              <button
                className="BtnClean"
                onClick={() => setOpenAdicionar(true)}
              >
                Adicionar
              </button>
            )}
          </div>

          <div className="contentList">{ListColumns}</div>
          <div className="content">
            <div className="containerListInfo">
              {tipoEmbalagensOptions.length > 0 ? (
                <>{List}</>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                    Não há registros aqui
                  </h1>
                </div>
              )}
            </div>
          </div>

          {openAdicionar && (
            <AdicionarTipoEmbalagem
              onSave={handleSaveTipo}
              onCancel={() => setOpenAdicionar(false)}
            />
          )}

          <ConfirmDeleteModal
            isOpen={isModalOpen}
            toggle={toggleModal}
            onConfirm={handleConfirmDelete}
            itemName={selectedTipoEmbalagem?.tipoEmbalagem ?? ""}
          />
        </div>
      )}
    </>
  );
};
export default AdminTipoEmbalagens;
